export const DeviceImportPanel = {
  flow: 'y',
  gap: 'Z',
  padding: 'A',
  round: 'A',
  background: 'inkMid',
  border: '1px solid inkBorder',

  PanelHeader: {
    flow: 'x',
    align: 'center flex-start',
    justifyContent: 'space-between',
    Title: { text: '{{ equipmentDevices | polyglot }}', fontSize: 'A', fontWeight: '700', color: 'inkText' },
    CollapseBtn: {
      extends: 'Button',
      text: (el, s) => s.root.devicesCollapsed ? '{{ expand | polyglot }}' : '{{ collapse | polyglot }}',
      fontSize: 'Y',
      padding: 'X Z',
      round: 'Y',
      background: 'inkSurface',
      color: 'inkMuted',
      border: '1px solid inkBorder',
      cursor: 'pointer',
      on: {
        click: (e, el, s) => s.root.update({ devicesCollapsed: !s.root.devicesCollapsed })
      }
    }
  },

  DeviceList: {
    flow: 'y',
    gap: 'Y',
    display: (el, s) => s.root.devicesCollapsed ? 'none' : 'flex',
    children: [
      { deviceName: 'Dexis Periapical Sensor', deviceType: 'Periapical X-ray', deviceStatus: 'connected', autoImport: true },
      { deviceName: 'Planmeca ProMax 3D', deviceType: 'Panoramic X-ray', deviceStatus: 'connected', autoImport: true },
      { deviceName: 'Carestream CS 8200 3D', deviceType: 'CBCT Scanner', deviceStatus: 'scanning', autoImport: false },
      { deviceName: 'iTero Element 5D', deviceType: 'Intraoral Scanner', deviceStatus: 'connected', autoImport: true },
      { deviceName: 'DEXIS IXS Cam', deviceType: 'Intraoral Camera', deviceStatus: 'disconnected', autoImport: false }
    ],
    childrenAs: 'state',
    childExtends: 'DeviceImportRow'
  }
}

export const DeviceImportRow = {
  flow: 'x',
  align: 'center flex-start',
  gap: 'Z',
  padding: 'Z',
  round: 'Y',
  background: 'inkSurface',
  border: '1px solid inkBorder',

  DeviceInfo: {
    flow: 'y',
    gap: 'W',
    flex: '1',
    DeviceName: { text: (el, s) => s.deviceName || '', fontSize: 'Z', fontWeight: '600', color: 'inkText' },
    DeviceType: { text: (el, s) => s.deviceType || '', fontSize: 'Y', color: 'inkMuted' }
  },

  Badge: { extends: 'DeviceStatusBadge' },

  AutoImportToggle: {
    flow: 'x',
    align: 'center center',
    gap: 'X',
    AutoLabel: { text: '{{ autoImport | polyglot }}', fontSize: 'Y', color: 'inkMuted' },
    Toggle: {
      width: '32px',
      height: '18px',
      round: 'B',
      cursor: 'pointer',
      transition: 'background 150ms ease',
      background: (el, s) => s.autoImport ? 'teal' : 'inkBorder',
      position: 'relative',
      Knob: {
        width: '14px',
        height: '14px',
        round: 'D',
        background: 'white',
        position: 'absolute',
        top: '2px',
        left: (el, s) => s.autoImport ? '16px' : '2px',
        transition: 'left 150ms ease'
      },
      on: {
        click: (e, el, s) => s.update({ autoImport: !s.autoImport })
      }
    }
  },

  ImportBtn: {
    extends: 'Button',
    text: '{{ importLatest | polyglot }}',
    fontSize: 'Y',
    padding: 'X Z',
    round: 'Y',
    background: 'inkText',
    color: 'inkMid',
    fontWeight: '500',
    cursor: 'pointer',
    opacity: (el, s) => s.deviceStatus === 'disconnected' ? '.4' : '1',
    pointerEvents: (el, s) => s.deviceStatus === 'disconnected' ? 'none' : 'auto'
  }
}
